export const API_URL = 'buffers/user'
export const ROUTE_NAME = 'buffers/user'
